import { OrdersDataGrid } from "./Orders";
import { query } from "../App";

export default function Warehouse() {
    return (<OrdersDataGrid
        filterData={[{
            field: "products.packaging",
            operator: "equals",
            value: true,
        }, {
            field: "status",
            operator: "different",
            value: 5,
        }]}
    />)
}